(function() { window.GUID_18be79a0_e2bb_411a_8eb8_cf519896a38c = { getGuid: function() { return "18be79a0-e2bb-411a-8eb8-cf519896a38c"; } }; })();
var CS;
(function (CS) {
    var CamLight;
    (function (CamLight) {
        var Models;
        (function (Models) {
            var Enums;
            (function (Enums) {
                let BallEventType;
                (function (BallEventType) {
                    BallEventType[BallEventType["Unknown"] = 0] = "Unknown";
                    BallEventType[BallEventType["BallHit"] = 1] = "BallHit";
                    BallEventType[BallEventType["Break"] = 2] = "Break";
                    BallEventType[BallEventType["Fault"] = 3] = "Fault";
                    BallEventType[BallEventType["Safe"] = 4] = "Safe";
                    BallEventType[BallEventType["EmptyInning"] = 5] = "EmptyInning";
                    BallEventType[BallEventType["BackOnTable"] = 6] = "BackOnTable";
                    BallEventType[BallEventType["NoBallHit"] = -2] = "NoBallHit";
                    BallEventType[BallEventType["WhiteScratch"] = -1] = "WhiteScratch";
                })(BallEventType = Enums.BallEventType || (Enums.BallEventType = {}));
            })(Enums = Models.Enums || (Models.Enums = {}));
        })(Models = CamLight.Models || (CamLight.Models = {}));
    })(CamLight = CS.CamLight || (CS.CamLight = {}));
})(CS || (CS = {}));

//# sourceMappingURL=BallEventType.pre.js.map
